export default __webpack_public_path__ + "static/media/undraw_order_confirmed_re_g0if.2760615b.svg";